import { ResponseGenerator } from 'common/type';
import { trimQueryData } from 'helpers/params';
import { call, put, takeLatest } from 'redux-saga/effects';

import { getAitGrAPI, getAitGrDetailAPI, addAitGrAPI, deleteAitGrAPI } from './api';
import {
  filterAitGr,
  filterAitGrSuccess,
  filterAitGrFailure,
  filterAitGrDrop,
  filterAitGrDropSuccess,
  getDetailAitGr,
  getDetailAitGrSuccess,
  getDetailAitGrFailure,
  registerAitGr,
  registerAitGrSuccess,
  registerAitGrFailure,
  deleteAitGr,
  deleteAitGrSuccess,
  deleteAitGrFailure,
} from './slice';
import {
  SearchAITGroupMasterRequest,
  DetailAITGroupMasterRequest,
  UpdateAITGroupMasterRequest,
  DeleteAITGroupMasterRequest,
} from 'api-types/src/types/ait-group-master';

function* fetchAitGrMaster({ payload }: { payload: SearchAITGroupMasterRequest }) {
  try {
    console.log('payload', payload);
    const response: ResponseGenerator = yield call(getAitGrAPI, trimQueryData(payload));
    yield put(filterAitGrSuccess(response.data));
  } catch (error) {
    console.log('error', error);
    yield put(filterAitGrFailure());
  }
}

function* fetchAitGrDropMaster({ payload }: { payload: SearchAITGroupMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(getAitGrAPI, trimQueryData(payload));
    yield put(filterAitGrDropSuccess(response.data));
  } catch (error) {
    yield put(filterAitGrFailure());
  }
}

function* fetchAitGrDetail({ payload }: { payload: DetailAITGroupMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(getAitGrDetailAPI, payload);
    yield put(getDetailAitGrSuccess(response.data));
  } catch (error: any) {
    yield put(getDetailAitGrFailure({ message: error?.message }));
  }
}

function* registerAitGrSaga({ payload }: { payload: UpdateAITGroupMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(addAitGrAPI, payload);
    yield put(registerAitGrSuccess(response));
  } catch (error: any) {
    yield put(registerAitGrFailure({ message: error?.message }));
  }
}

function* deleteAitGrSaga({ payload }: { payload: DeleteAITGroupMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(deleteAitGrAPI, payload);
    yield put(deleteAitGrSuccess(response));
  } catch (error: any) {
    yield put(deleteAitGrFailure({ message: error?.message }));
  }
}

function* watchAitGrMaster() {
  yield takeLatest(filterAitGr, fetchAitGrMaster);
  yield takeLatest(filterAitGrDrop, fetchAitGrDropMaster);
  yield takeLatest(getDetailAitGr, fetchAitGrDetail);
  yield takeLatest(registerAitGr, registerAitGrSaga);
  yield takeLatest(deleteAitGr, deleteAitGrSaga);
}

export default watchAitGrMaster;
